module.exports = __webpack_public_path__ + "static/hero-packages-shuttleid-scan-ticket-34308ca34b47c959639dc9f584f272ee.jpg";